import { render, staticRenderFns } from "./companyTypeListing.vue?vue&type=template&id=68d6b4d4&"
import script from "./companyTypeListing.vue?vue&type=script&lang=js&"
export * from "./companyTypeListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports